<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-4 white--text">
          <v-spacer></v-spacer>
          <v-icon dark right @click="dialog = !dialog">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <div>
            <Agrupadorprogramas ref="xagrupador" v-on:xnewagrupacion="xnewagrupacion" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Agrupadorprogramas from '@/views/Agrupadorprogramas.vue';
  export default {
    data: () => ({
      dialog: false,
    }),
    components: { Agrupadorprogramas },
    methods: {
      openmodal(programa) {
        this.dialog = true;
        const vue = this;
        setTimeout(() => {
          vue.$refs['xagrupador'].openmodal(programa);
        }, 500);
      },
      xnewagrupacion(msg) {
        if (msg == 'success') {
          const vue = this;
          setTimeout(() => {
            vue.dialog = false;
          }, 1200);
        }
      },
      enviar() {},
    },
    mounted() {},
  };
</script>
